/**
 * @group EHR
 * @summary EHR domain exports
 * 
 * <blockquote>
 * Exports all EHR domain components including constants, enums, models, types, and relations.
 * This provides a complete EHR integration data model for tracking patient connections to external
 * EHR systems and health record document uploads.
 * </blockquote>
 * 
 * @example
 * ```typescript
 * import { 
 *   // Constants
 *   EHR_UPLOAD_STATUS,
 *   // Enums
 *   EhrProviderEnum,
 *   UploadStatusEnum,
 *   // Models
 *   ehrIntegrations,
 *   healthRecordUploads,
 *   // Types
 *   EhrIntegration,
 *   HealthRecordUpload,
 *   EhrProvider,
 *   UploadStatus,
 *   // Relations
 *   ehrIntegrationRelations,
 *   healthRecordUploadRelations,
 *   // Repositories
 *   EhrIntegrationRepository,
 *   HealthRecordUploadRepository
 * } from '@shared/db';
 * ```
 */

// Constants
export * from './constants';

// Enums
export * from './enums';

// Models
export * from './models';

// Types
export * from './types';
export * from './types/EhrProvider';
export * from './types/UploadStatus';

// Relations
export * from './relations';

// Repositories
export * from './repositories/EhrIntegrationRepository';
export * from './repositories/HealthRecordUploadRepository';
